import React, { useState } from "react";
import DashboardLayout from "../../Components/Layouts/DashBoardLayout";
import { CardTitle } from "../../Components/CustomComponents";
import DispatcherCard from "../../Components/Cards/DispatcherCard";
import { Col, Row } from "react-bootstrap";
import { dispachterdata } from "../Dashboard";
import AlertDispatcherModal from "../../Components/Modals/AlertDispatcherModal";
import { useSelector } from "react-redux";
import socketIo from "../../config/Socket";

const Alert = () => {
  const [alertModal, setAlertModal] = useState(false);
  const data = useSelector((state) => state.officerInfo);
  const [modalData, setModalData] = useState({});
  const [modaluserId, setMdoalUserId] = useState("");
  const filteredAlertDispatcher =
    data?.data?.filter(
      (item) => item.heart_rate > 85 && item.heart_rate < 100
    ) || [];

  const handleModalClose = () => {
    setAlertModal((prev) => !prev);
  };

  const handleResponse = (data, successMessage, errorMessage) => {
    setModalData(data);
    leaveRoom(modaluserId);
  };

  const joinRoom = (userId) => {
    socketIo.emit("_joinUserRoom", userId);
    socketIo.emit("_getOfficer", userId);
    socketIo.on("getOfficer_", (data) =>
      handleResponse(data, "", "Error getting officer details")
    );
  };

  const leaveRoom = (userId) => {
    socketIo.emit("_leaveUserRoom", userId);
  };

  return (
    <DashboardLayout>
      <section>
        <CardTitle text="Alert" classes="text-black fs-5 fw-bold mb-2" />
        <Row className={`mb-5`}>
          {filteredAlertDispatcher.length > 0 ? (
            filteredAlertDispatcher.map((item) => (
              <Col
                className={`mt-2 mb-2`}
                lg={4}
                md={4}
                sm={6}
                key={item.id}
                onClick={() => {
                  setAlertModal(true);
                  joinRoom(item.slug);
                  setMdoalUserId(item.slug);
                }}
              >
                <DispatcherCard data={item} />
              </Col>
            ))
          ) : (
            <p>Data Not Available</p>
          )}
        </Row>
      </section>
      {alertModal ? (
        <AlertDispatcherModal handleClose={handleModalClose} data={modalData} />
      ) : null}
    </DashboardLayout>
  );
};

export default Alert;
